export class StudentDetail {

    public clgtype: string;
    public studno: string;
    public dateofbirth: string;
    public yearofpas: string="";
    public studname: string;
    public clgcode: string;
    public clgname: string;
    public dob: Date = new Date();
    public age: number;
    public fathersname: string;
    public gender: string;
    public doorno: string;
    public add: string;
    public add1: string;
    public street: string;
    public area: string;
    public city: string;
    public pincode: string;
    public mobno: string;
    public cnfrmmobno: string;
    public fathersmobno: string;
    public indiaplc: string;
    public abroad: string;
    public travel: string;
    public hobbies: string;
    public extra: string;
    public clgrollno: string;
    public fathersocc: string;
    public mothersname: string;
    public mothersocc: string;
    public dept: string;
    public edu: string;
    public email: string;
    public cnfrmemail: string;
    public tnthmark: number;
    public twelthmark: number;
    public tnthmaths: number;
    public twelthmaths: number;
    public cgpa: number;
    public image: any;
    public studentcount: string;
    public clgAddress:string;
    public stuimg:any;
    public type: string;

    constructor() {
        this.doorno = '';
        this.add = '';
        this.add1 = '';
        this.street = '';
        this.area = '';
        this.city = '';
        this.pincode = '';
        this.extra = '';
        this.hobbies = '';
        this.yearofpas = new Date().getFullYear()+'-03';
        // this.yearofpas = '2021-03';
    }

}
